import { render, staticRenderFns } from "./TwoImage.vue?vue&type=template&id=8bac0b12&scoped=true&"
import script from "./TwoImage.vue?vue&type=script&lang=js&"
export * from "./TwoImage.vue?vue&type=script&lang=js&"
import style0 from "./TwoImage.vue?vue&type=style&index=0&id=8bac0b12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bac0b12",
  null
  
)

export default component.exports